import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="bg-[#F6F4EE] min-h-screen text-[#0D1F2D]">
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        <XCircle size={64} className="text-[#0F6E5B] mx-auto" />
        <h1 className="font-display text-4xl font-bold mt-6">Plată anulată.</h1>
        <p className="mt-3 text-[#52616B]">Nu ți-a fost reținută nicio sumă.</p>
        <Link to="/preturi" className="mt-8 inline-flex bg-[#0D1F2D] text-[#F6F4EE] px-6 h-11 rounded-sm font-medium items-center hover:bg-[#0F6E5B] transition-colors">Vezi planurile</Link>
      </div>
    </main>
  );
}
